export default {
  FETCH_EFT_HISTORY_REQUEST: 'FETCH_EFT_HISTORY_REQUEST',
  FETCH_EFT_HISTORY_SUCCESS: 'FETCH_EFT_HISTORY_SUCCESS',
  FETCH_EFT_HISTORY_FAILURE: 'FETCH_EFT_HISTORY_FAILURE',

  FETCH_EFT_EXTENSIONS_REQUEST: 'FETCH_EFT_EXTENSIONS_REQUEST',
  FETCH_EFT_EXTENSIONS_SUCCESS: 'FETCH_EFT_EXTENSIONS_SUCCESS',
  FETCH_EFT_EXTENSIONS_FAILURE: 'FETCH_EFT_EXTENSIONS_FAILURE',

  FETCH_RETAILER_EFT_DETAIL_DATE_REQUEST: 'FETCH_RETAILER_EFT_DETAIL_DATE_REQUEST',
  FETCH_RETAILER_EFT_DETAIL_DATE_SUCCESS: 'FETCH_RETAILER_EFT_DETAIL_DATE_SUCCESS',
  FETCH_RETAILER_EFT_DETAIL_DATE_FAILURE: 'FETCH_RETAILER_EFT_DETAIL_DATE_FAILURE',

  DOWNLOAD_EFT_INVOICE_REQUEST: 'DOWNLOAD_EFT_INVOICE_REQUEST',
  DOWNLOAD_EFT_INVOICE_SUCCESS: 'DOWNLOAD_EFT_INVOICE_SUCCESS',
  DOWNLOAD_EFT_INVOICE_FAILURE: 'DOWNLOAD_EFT_INVOICE_FAILURE',
};



// WEBPACK FOOTER //
// ./src/modules/dashboard/actions/eft-history/action-types.js